import { z } from "zod";

import { constantsData } from "@/data";
import { OfflineDataSourceAmountFieldDataActionEnum } from "@/enums";

export const transformOfflineDataSourceAmountFieldFormSchema = z.object({
    creditColumn: z.string().optional(),
    creditValues: z.union([z.string(), z.array(z.string())]).optional(),
    dataAction: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    dataType: z.string().optional(),
    debitColumn: z.string().optional(),
    debitValues: z.union([z.string(), z.array(z.string())]).optional(),
}).superRefine((values, ctx) => {
    const { dataAction } = values;

    // Case: dataAction is empty or ARITHMETIC → all optional (nothing to validate)
    if (!dataAction || dataAction === OfflineDataSourceAmountFieldDataActionEnum.ARITHMETIC) return;

    // Case: SEPARATE → creditColumn and debitColumn are required
    if (dataAction === OfflineDataSourceAmountFieldDataActionEnum.SEPARATE) {
        if (!values.creditColumn || values.creditColumn.trim() === "") {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: constantsData.msgs.requiredField,
                path: ["creditColumn"],
            });
        }

        if (!values.debitColumn || values.debitColumn.trim() === "") {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: constantsData.msgs.requiredField,
                path: ["debitColumn"],
            });
        }
        return;
    }

    // Case: COMBINE or CONDITIONAL → creditValues, debitValues, and dataType are required
    const creditValues = Array.isArray(values.creditValues) ? values.creditValues : [values.creditValues];

    const debitValues = Array.isArray(values.debitValues) ? values.debitValues : [values.debitValues];

    if (!creditValues || creditValues.length === 0 || !creditValues[0]) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: constantsData.msgs.requiredField,
            path: ["creditValues"],
        });
    }

    if (!debitValues || debitValues.length === 0 || !debitValues[0]) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: constantsData.msgs.requiredField,
            path: ["debitValues"],
        });
    }

    if (!values.dataType || values.dataType.trim() === "") {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: constantsData.msgs.requiredField,
            path: ["dataType"],
        });
    }
});
